import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  HealthOrganizationCheckoutSummary,
  UserCheckout,
  UsersGroupedByCategory,
} from "src/app/core/model/v2/practice/RoleGroupedUser";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-setup-checkout",
  templateUrl: "./setup-checkout.component.html",
  styleUrls: ["./setup-checkout.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class SetupCheckoutComponent implements OnInit {
  roleGroupedUsers: UsersGroupedByCategory[];
  healthOrganizationCheckoutSummary: HealthOrganizationCheckoutSummary;
  errorMessage: string;
  changeCard: boolean = false;
  columnsToDisplay = [
    "roleCategory",
    "numberOfPersons",
    "totalPendingOneTimeFee",
    "totalPendingMonthlyFee"
  ];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  displayedColumns = [
    "name",
    // "roleCategory",
    "pendingOneTimeFee",
    "monthlyFee",
  ];
  expandedElement: UserCheckout | null;

  constructor(
    private router: Router,
    private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.LoadCheckoutSummary();
  }
  private LoadCheckoutSummary() {
    this.loaderService.show();
    this.practiceService.getHealthOrganizationCheckoutInformation().subscribe(
      (checkoutSummary) => {
        this.loaderService.hide();
        this.healthOrganizationCheckoutSummary = checkoutSummary;
        this.roleGroupedUsers = checkoutSummary.roleGroupedUsers.filter(
          (x) =>
            x.roleCategory == "Medical Professional" ||
            x.roleCategory == "Physician" ||
            x.roleCategory == "APP" ||
            x.roleCategory == "Staff" ||
            x.roleCategory == "Practice"
        );
        this.roleGroupedUsers=this.roleGroupedUsers.filter((x)=>x.totalPendingMonthlyFee>0 || x.totalPendingOneTimeFee>0);
        this.roleGroupedUsers.forEach(element => {
          element.numberOfPersons = element.users != null ? element.users.length : 0;
        });
        console.log(this.roleGroupedUsers);
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  GetPhysicianGroup() {
    if (this.roleGroupedUsers)
      return this.roleGroupedUsers.find((rg) => rg.roleCategory == "Physician");
  }

  GetMedicalProfessionalGroup() {
    if (this.roleGroupedUsers)
      return this.roleGroupedUsers.find(
        (rg) => rg.roleCategory == "Medical Professional"
      );
  }

  GetAPPGroup() {
    if (this.roleGroupedUsers)
      return this.roleGroupedUsers.find((rg) => rg.roleCategory == "APP");
  }

  GetStaffGroup() {
    if (this.roleGroupedUsers)
      return this.roleGroupedUsers.find((rg) => rg.roleCategory == "Staff");
  }

  hasPaymentInfo(): boolean {
    if (this.healthOrganizationCheckoutSummary) {
      return this.healthOrganizationCheckoutSummary.paymentInformation !== null;
    }

    return false;
  }

  hasPendingActivations(): boolean {
    if (this.healthOrganizationCheckoutSummary)
      return (
        this.healthOrganizationCheckoutSummary.grandTotalPendingOneTimeFee >
          0 ||
        this.healthOrganizationCheckoutSummary
          .grandTotalGlobalAdministratorsPendingPay > 0
      );
  }

  goBack() {
    this.location.back();
  }

  completeCheckout() {
    this.pay();
  }

  reload() {
    this.LoadCheckoutSummary();
  }

  addChangeCard() {
    this.changeCard = !this.changeCard;
  }

  // canActivateTrial()
  // {
  //   return this.healthOrganizationCheckoutSummary.healthOrganizationEndOfTrialDate == null;
  // }

  ActivateTrial() {
    this.loaderService
      .blockWithLoader(this.practiceService.activateTrial())
      .subscribe(
        (res) => {
          if (res.result) {
            this.router.navigate(["/physician/profile/setupCompleted"]);
          } else {
            this.errorMessage = res.resultStatus.message;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  pay() {
    this.loaderService.show();
    this.practiceService
      .ChargeUserOrganizationForTheOneTimeFeeAndUpdateSubscription()
      .subscribe(
        (res) => {
          if (res.resultStatus.isSuccess) {
            this.errorMessage = "";
            this.router.navigate(["/physician/profile/setupCompleted"]);
          } else {
            this.errorMessage = res.resultStatus.message;
          }
          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }
}
